import React, { useEffect, useState } from "react";
import HeaderMenu from "../../../components/Header";
import Sidebar from "../../../components/NavBar";

import {
  Layout,
  Row,
  Col,
  Divider,
  List,
  Typography,
  Table,
  Tag,
  Space,
  Form,
  Checkbox,
  Button,
  Input,
  Image,
  Select,
  Modal,
} from "antd";
import { Container, Grid } from "semantic-ui-react";
import { LeftOutlined, CloseOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useMaestras } from "../../../hooks/useMaestras";
export default function EditFormEvaluacionCriteriosModel(props: any) {
  const { Content } = Layout;
  const { Option } = Select;
  const { editFormData, setEditFormData } = props;

  const [editData, setEditData] = useState<any>();
  const { criterios, obtenerCriterios } = useMaestras()

  useEffect(() => {
    obtenerCriterios();
    setEditData(editFormData);
  }, [props]);

  console.log("editData: frm ", editData);
  return (
    <div>
      <Layout className="mb-2  model_info mdl_pd_lf_rg no-margin background-color-FFFFFF" style={{ borderRadius: "15px 15px 15px 15px", padding: "16px" }}>
        <Content className="model__header asgevl_head">
          <Content className="mdl_header_containt">
            <Row className="tbl_md_heading_box">
              <Col span={24} className="">
                <h3 className="asgevl_mdl_form_head font-size-14px font-family-Montserrat-SemiBold">Editar criterio de evaluación</h3>
              </Col>
            </Row>
          </Content>
        </Content>

        <Content className="asgevl__top_mdl_box">
          <Content className="">
            <Form>
              <Row gutter={[16, 0]}>
                <Col span={24}>
                  <Content className="p-1">
                    <label className="form--lable asgevl_form_lable font-size-12px font-family-Montserrat-SemiBold">Criterio de evaluación</label>
                    <Select
                      defaultValue="Seleccionar..."
                      style={{ width: "100%" }}
                      value={editData?.nombre}
                      className="eval--selct"
                      onChange={(e) =>
                        setEditFormData({
                          ...editData,
                          nombre: e,
                        })
                      }
                    >
                      {criterios.map(({ id, nombre }: any) =>
                        <Select.Option key={id} value={nombre}>{nombre}</Select.Option>
                      )}
                    </Select>
                  </Content>
                </Col>
              </Row>
              <Row gutter={[16, 0]}>
                <Col span={12}>
                  <Content className="p-1">
                    <label className="form--lable asgevl_form_lable font-size-12px font-family-Montserrat-SemiBold">Descripción</label>
                    <Input.TextArea
                      maxLength={240}
                      showCount
                      className="eval--textarea"
                      value={editData?.descripcion}
                      onChange={(e) =>
                        setEditFormData({
                          ...editData,
                          descripcion: e.target.value,
                        })
                      }
                    />
                  </Content>
                </Col>
                <Col span={12}>
                  <Content className="p-1">
                    <label className="form--lable asgevl_form_lable font-size-12px font-family-Montserrat-SemiBold">Puntaje de evaluación</label>
                    <Input
                      min={0}
                      max={100}
                      maxLength={3}
                      // type="number"
                      className="eval-input evl_cat_input"
                      value={editData?.porcentaje}
                      onChange={(e) => {
                        e.target.value = e.target.value.replace(/\D/, "")
                        setEditFormData({
                          ...editData,
                          porcentaje: e.target.value,
                        })
                      }}
                    />
                  </Content>
                </Col>
              </Row>
            </Form>
          </Content>
          <Content className="mb-2">
            <Row className="width-100">
              <Col span={24} className="form--btm-btn-box justify-content-flex-end">
                <Button className="button-azul-radius" onClick={() => props.onEdit(editData)}>
                  Guardar Cambios
                </Button>
              </Col>
            </Row>
          </Content>
        </Content>
      </Layout>
    </div>
  );
}
